import { Action } from '@ngrx/store';

export enum SocketActionTypes {
    SendMessage = '[Socket] Send Message',
    SendMessageSuccess = '[Socket] Send Message Success',
    SendMessageFailure = '[Socket] Send Message Failure',
    SentMessageNotAllowed = '[Socket] Sent Message Not Allowed',
    RemoveContact = '[Socket] Remove Contact',
    RemoveContactSuccess = '[Socket] Remove Contact Success',
    MessageReceived = '[Socket] Message Received',
    GetRecentlyRecords = '[Socket] Get Recently Records',
    GetRecentlyRecordsComplete = '[Socket] Get Recently Records Completes',
    MarkMessagesAsRead = '[Socket] Mark Messages as Read',
    MarkAllMessagesAsRead = '[Socket] Mark All Messages as Read',
    GetRecentlyRecordsByUser = '[Socket] Get Recently Records By User',
    GetRecentlyRecordsByUserComplete = '[Socket] Get Recently Records By User Complete',
    ClearChatHistory = '[Socket] Clear Chat History',
    SelectContact = '[Socket] Select Contact',
    DeselectContact = '[Socket] Deselect Contact',
    LoadPreviousRecords = '[Socket] Load Previous Records',
    GetSettings = '[Socket] Get Settings',
    GetSettingsSuccess = '[Socket] Get Settings Success',
    ToggleSettingsFriendOnly = '[Socket] Toggle Settings Friend Only',
    Report = '[Socket] Report',
    ReportSuccess = '[Socket] Report Success',
    GetFollowStatus = '[Socket] Get Follow Status',
    GetFollowStatusSuccess = '[Socket] Get Follow Status Success',
    ChangeFollowStatus = '[Socket] Change Follow Status',
    ChangeFollowStatusSuccess = '[Socket] Change Follow Status Success',
    ClearAll = '[Socket] Clear All',
    AddUserToBlock = '[Socket] Add User To Block'
}
export class SendMessage implements Action {
    readonly type = SocketActionTypes.SendMessage;
    constructor(public payload?: any) { }
}
export class SendMessageSuccess implements Action {
    readonly type = SocketActionTypes.SendMessageSuccess;
    constructor(public payload?: any) { }
}
export class SendMessageFailure implements Action {
    readonly type = SocketActionTypes.SendMessageFailure;
    constructor(public payload?: any) { }
}
export class SentMessageNotAllowed implements Action {
    readonly type = SocketActionTypes.SentMessageNotAllowed;
    constructor(public payload?: any) { }
}
export class RemoveContact implements Action {
    readonly type = SocketActionTypes.RemoveContact;
    constructor(public payload?: any) { }
}
export class RemoveContactSuccess implements Action {
    readonly type = SocketActionTypes.RemoveContactSuccess;
    constructor(public payload?: any) { }
}
export class MessageReceived implements Action {
    readonly type = SocketActionTypes.MessageReceived;
    constructor(public payload?: any) { }
}
export class GetRecentlyRecords implements Action {
    readonly type = SocketActionTypes.GetRecentlyRecords;
}
export class GetRecentlyRecordsComplete implements Action {
    readonly type = SocketActionTypes.GetRecentlyRecordsComplete;
    constructor(public payload?: any) { }
}
export class MarkMessagesAsRead implements Action {
    readonly type = SocketActionTypes.MarkMessagesAsRead;
    constructor(public payload?: any) { }
}
export class MarkAllMessagesAsRead implements Action {
    readonly type = SocketActionTypes.MarkAllMessagesAsRead;
}
export class GetRecentlyRecordsByUser implements Action {
    readonly type = SocketActionTypes.GetRecentlyRecordsByUser;
    constructor(public payload?: any) { }
}
export class GetRecentlyRecordsByUserComplete implements Action {
    readonly type = SocketActionTypes.GetRecentlyRecordsByUserComplete;
    constructor(public payload?: any) { }
}
export class ClearChatHistory implements Action {
    readonly type = SocketActionTypes.ClearChatHistory;
    constructor(public payload?: any) { }
}
export class SelectContact implements Action {
    readonly type = SocketActionTypes.SelectContact;
    constructor(public payload?: any) { }
}
export class DeselectContact implements Action {
    readonly type = SocketActionTypes.DeselectContact;
}
export class LoadPreviousRecords implements Action {
    readonly type = SocketActionTypes.LoadPreviousRecords;
    constructor(public payload?: any) { }
}
export class GetSettings implements Action {
    readonly type = SocketActionTypes.GetSettings;
}
export class GetSettingsSuccess implements Action {
    readonly type = SocketActionTypes.GetSettingsSuccess;
    constructor(public payload?: any) { }
}
export class ToggleSettingsFriendOnly implements Action {
    readonly type = SocketActionTypes.ToggleSettingsFriendOnly;
}
export class Report implements Action {
    readonly type = SocketActionTypes.Report;
    constructor(public payload?: any) { }
}
export class ReportSuccess implements Action {
    readonly type = SocketActionTypes.ReportSuccess;
}
export class GetFollowStatus implements Action {
    readonly type = SocketActionTypes.GetFollowStatus;
    constructor(public payload?: any) { }
}
export class GetFollowStatusSuccess implements Action {
    readonly type = SocketActionTypes.GetFollowStatusSuccess;
    constructor(public payload?: any) { }
}
export class ChangeFollowStatus implements Action {
    readonly type = SocketActionTypes.ChangeFollowStatus;
    constructor(public payload?: any) { }
}
export class ChangeFollowStatusSuccess implements Action {
    readonly type = SocketActionTypes.ChangeFollowStatusSuccess;
    constructor(public payload?: any) { }
}
export class ClearAll implements Action {
    readonly type = SocketActionTypes.ClearAll;
}

export class AddUserToBlock implements Action{
    readonly type = SocketActionTypes.AddUserToBlock;

}

export type SocketActions =
    | SendMessage
    | SendMessageSuccess
    | SendMessageFailure
    | SentMessageNotAllowed
    | RemoveContact
    | RemoveContactSuccess
    | MessageReceived
    | GetRecentlyRecords
    | GetRecentlyRecordsComplete
    | MarkMessagesAsRead
    | MarkAllMessagesAsRead
    | GetRecentlyRecordsByUser
    | GetRecentlyRecordsByUserComplete
    | ClearChatHistory
    | SelectContact
    | DeselectContact
    | LoadPreviousRecords
    | GetSettings
    | GetSettingsSuccess
    | ToggleSettingsFriendOnly
    | Report
    | ReportSuccess
    | GetFollowStatus
    | GetFollowStatusSuccess
    | ChangeFollowStatus
    | ChangeFollowStatusSuccess
    | ClearAll
    | AddUserToBlock
    ;
